import Vue from 'vue';
import Vuelidate from 'vuelidate';
import Vuex from 'vuex';
import VueI18n from 'vue-i18n';
import VueRouter from 'vue-router';

import App from './App.vue';
import ScriptLoader from './helpers/script-loader';

import axios from './setup/axios';
import config from './setup/config';
import i18n from './setup/locale';
import router from './setup/router';
import store from './store/store';
import './setup/fontawesome';
import './setup/elementui';
import './setup/router-guards';
import './setup/axios-interceptors';
import 'nprogress/nprogress.css';

window.Vue = Vue;
window.Vuex = Vuex;
window.VueI18n = VueI18n;
window.VueRouter = VueRouter;
window.axios = axios;

window.microfrontends = {
  shared: {
    axios,
    config,
    store,
    i18n,
  },
};

Vue.use(Vuelidate);

Vue.config.productionTip = false;

Promise.all([
  ScriptLoader.load(`${config.microservices.webcontent}/css/styles.css`),
  ScriptLoader.load(`${config.microservices.webcontent}/css/webeo.table.css`),
  ScriptLoader.load(`${config.microservices.webcontentvue}/js/main.js`),
  ScriptLoader.load(`${config.microservices.webcontentvue}/css/main.css`),
  store.dispatch('initialise'),
]).finally(() => {
  new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
    validations: {},
  }).$mount('#app');
});
